module.exports = "<div *ngIf=\"rowData\">{{(rowData.creationDate._seconds)*1000 | date:'dd-MM-yyyy HH:mm'}}</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/order-date/order-date.component.html
// module id = ./src/app/shared/order-date/order-date.component.html
// module chunks = main